<div *ngIf="model" class="component-container">
  <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 form-column margin-align">
    <div class="margin-header-align section-heading text-uppercase">
      <app-section-header
        [title]="'regep.provisioning-of-current-transformers.title' | translate"
        [tooltip]="'tooltips.technical-data.regep.provisioning-of-current-transformers' | translate"></app-section-header>
      <div class="section-buttons">
        <lock-unlock-buttons
          [showLockButton]="isDetailsView"
          [showUnlockButton]="isDetailsView"
          [isLocked]="getSectionLocked()"
          [areButtonsDisabled]="!(isModeratorRole() && editabilityBasedOnProcessStatus.internalRoles)"
          (lockButtonClickedEvent)="lockSection()"
          (unLockButtonClickedEvent)="unlockSection()"></lock-unlock-buttons>
        <i
          *ngIf="isDetailsView"
          class="pi pi-comment"
          [ngClass]="isCommentVisible || getSectionComment() ? 'lock-icon-style' : 'unlock-icon-style'"
          [pTooltip]="showCommentTooltip() ? ('comment-section.comment-tooltip' | translate) : null"
          [tooltipPosition]="showCommentTooltip() ? 'bottom' : null"
          (click)="showComment()"></i>
      </div>
    </div>
  </div>
  <section-comment
    [isCommentTextInputVisible]="isModeratorRole() && (isCommentVisible || getSectionComment())"
    [isCommentTextVisible]="!isModeratorRole()"
    [isCommentSaveVisible]="!getSectionComment()"
    [isCommentDeleteButtonDisabled]="!editabilityBasedOnProcessStatus.internalRoles"
    [comment]="getSectionComment()"
    (saveCommentEvent)="updateComment($event)"
    (deleteCommentEvent)="deleteComment()"
    (changeTextEvent)="changeCommentText.emit($event)"></section-comment>
  <div [ngClass]="{ 'disable-section': getSectionLocked() && applicationId }" class="section-wrapper margin-align">
    <div class="margin-align">
      <div class="section-column top-bottom-margin">
        <div class="section-field">
          <label class="ui-g-5 required">
            {{ 'regep.provisioning-of-current-transformers.has_technical_reasons' | translate }}
          </label>
          <p-radioButton
            name="technical_reasons"
            [value]="true"
            label="{{ 'grid-comp.yes' | translate }}"
            class="mr-2"
            (ngModelChange)="hasTechnicalReasonsChange($event)"
            [(ngModel)]="model.has_technical_reasons"
            required
            [disabled]="isSectionDisabled"></p-radioButton>
          <p-radioButton
            name="technical_reasons"
            [value]="false"
            label="{{ 'grid-comp.no' | translate }}"
            class="mr-2"
            (ngModelChange)="hasTechnicalReasonsChange($event)"
            [(ngModel)]="model.has_technical_reasons"
            required
            [disabled]="isSectionDisabled"></p-radioButton>
        </div>

        <ng-container *ngIf="model.has_technical_reasons">
          <div class="section-field">
            <label class="ui-g-5 required">
              {{ 'regep.provisioning-of-current-transformers.operator' | translate }}
            </label>
            <p-radioButton
              name="operator"
              [value]="operators.lsw"
              label="{{ 'regep.provisioning-of-current-transformers.operator-lsw' | translate }}"
              class="mr-2"
              (ngModelChange)="operatorChange($event)"
              [(ngModel)]="model.operator"
              required
              [disabled]="isSectionDisabled"></p-radioButton>
            <p-radioButton
              name="operator"
              [value]="operators.other"
              label="{{ 'regep.provisioning-of-current-transformers.operator-other' | translate }}"
              class="mr-2"
              (ngModelChange)="operatorChange($event)"
              [(ngModel)]="model.operator"
              required
              [disabled]="isSectionDisabled"></p-radioButton>
          </div>

          <ng-container *ngIf="model.operator === operators.lsw">
            <ng-container *ngFor="let transformer of model.current_transformers; index as i">
              <div class="section-field">
                <label class="ui-g-5 required">
                  {{ 'regep.provisioning-of-current-transformers.number-of-transformers-needed' | translate }}
                </label>
                <p-inputNumber
                  class="form-control"
                  [(ngModel)]="transformer.number_of_transformers_needed"
                  name="number_of_transformers_needed{{ i }}"
                  required
                  mode="decimal"
                  [useGrouping]="false"
                  [disabled]="isSectionDisabled"></p-inputNumber>
              </div>

              <div class="section-field">
                <label class="ui-g-5 required">
                  {{ 'regep.provisioning-of-current-transformers.size-of-transformer' | translate }}
                </label>
                <p-dropdown
                  class="form-control"
                  [options]="transformerSizes"
                  [(ngModel)]="transformer.size_of_transformer"
                  optionValue="value"
                  placeholder="Please select"
                  name="size_of_transformer{{ i }}"
                  [attr.data-testId]="'size_of_transformer' + i"
                  required
                  [disabled]="isSectionDisabled"></p-dropdown>

                <div
                  *ngIf="model.current_transformers.length > 1"
                  (click)="removeTransformer(i)"
                  class="pi pi-trash pointer-cursor right-aligned ui-g-1"
                  [ngClass]="{ 'disable-section': isSectionDisabled }"></div>
              </div>
            </ng-container>

            <div class="section-field" [ngClass]="isSectionDisabled ? 'disable-section' : ''">
              <i (click)="addTransformer()" class="pi pi-plus plus-icon margin-zero" tabindex="0" appEnterClick></i>
              <label class="field-label">
                {{ 'regep.provisioning-of-current-transformers.add-transformer' | translate }}
              </label>
            </div>

            <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12">
              <label class="ui-g-5 required">
                {{ 'regep.provisioning-of-current-transformers.preferred-pickup-date' | translate }}
              </label>
              <div *ngIf="'app.calendar-settings' | translate as locale" class="upload-padding">
                <p-calendar
                  tabIndex="0"
                  appCalendarEscapeClose
                  name="preferred_date_for_pickup"
                  [locale]="locale"
                  [dateFormat]="dateFormat.dateFormat"
                  [placeholder]="dateFormat.placeholder"
                  [monthNavigator]="true"
                  [yearNavigator]="true"
                  [minDate]="minDate"
                  class="doc-submit-datepicker"
                  dateFormat="string"
                  id="preferred_date_for_pickup"
                  inputId="basic"
                  yearRange="2023:2080"
                  required
                  [disabled]="isSectionDisabled"
                  [(ngModel)]="model.preferred_date_for_pickup"></p-calendar>
              </div>
            </div>

            <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12">
              <label [ngClass]="{ required: canModeratorEdit }" class="ui-g-5">
                {{ 'regep.provisioning-of-current-transformers.confirmed-pickup-date' | translate }}
              </label>
              <div *ngIf="'app.calendar-settings' | translate as locale" class="upload-padding">
                <p-calendar
                  tabIndex="0"
                  appCalendarEscapeClose
                  name="confirmed_date_for_pickup"
                  [locale]="locale"
                  [dateFormat]="dateFormat.dateFormat"
                  [placeholder]="dateFormat.placeholder"
                  [monthNavigator]="true"
                  [yearNavigator]="true"
                  [minDate]="minDate"
                  class="doc-submit-datepicker"
                  dateFormat="string"
                  id="confirmed_date_for_pickup"
                  inputId="basic"
                  yearRange="2023:2080"
                  [required]="canModeratorEdit"
                  [disabled]="!canModeratorEdit"
                  [(ngModel)]="model.confirmed_date_for_pickup"></p-calendar>
              </div>
            </div>
          </ng-container>
        </ng-container>
      </div>
    </div>
  </div>
</div>
